module.exports = __webpack_public_path__ + "img/coolant_replace.cdd1dc2e.svg";